module.exports = __webpack_public_path__ + "img/pp.0bab6574.jpeg";